import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import SimpleDialog from 'core/components/Dialogs/SimpleDialog';
import { getRoleName } from 'core/utils/userUtils';
import { UserRoleEnum } from 'models/enums/userRoleEnum';
import type { FC } from 'react';

const RoleComparisonDialog: FC<RoleComparisonProps> = ({ open, onClose }) => {
  const accessData = [
    {
      action: 'Редактирование информации об организации',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Редактирование проектов',
      supervisor: true,
      manager: 'Только свои',
      worker: 'Только свои',
    },
    {
      action: 'Редактирование наценок',
      supervisor: true,
      manager: 'Только свои',
      worker: 'Только свои',
    },
    {
      action: 'Доступ к разделу "Сотрудники"',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Доступ к разделу "Клиенты"',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Доступ к разделу "Товары"',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Редактирование платежей',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Доступ к выплатам по заказу',
      supervisor: true,
      manager: 'Только свои',
      worker: 'Только свои',
    },
    {
      action: 'Управление скидками заказа',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Настройка модулей приложения',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Редактирование добавочного номера Mango Office',
      supervisor: true,
      manager: false,
      worker: false,
    },
    {
      action: 'Управление API ключом Mango Office',
      supervisor: true,
      manager: false,
      worker: false,
    },
  ];

  const getValue = (val: boolean | string): string | JSX.Element =>
    typeof val === 'boolean' ? val ? <CheckCircleIcon color='primary' /> : '—' : val;

  return (
    <SimpleDialog
      title={'Роли пользователей'}
      open={open}
      onClose={onClose}
      actions={<Button onClick={onClose}>Закрыть</Button>}
      content={
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>{getRoleName(UserRoleEnum.Supervisor)}</TableCell>
                <TableCell>{getRoleName(UserRoleEnum.Manager)}</TableCell>
                <TableCell>{getRoleName(UserRoleEnum.Worker)}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {accessData.map((row) => (
                <TableRow key={row.action}>
                  <TableCell variant='head'>{row.action}</TableCell>
                  <TableCell>{getValue(row.supervisor)}</TableCell>
                  <TableCell>{getValue(row.manager)}</TableCell>
                  <TableCell>{getValue(row.worker)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      }
    />
  );
};

export interface RoleComparisonProps {
  open: boolean;
  onClose: VoidFunction;
}

export default RoleComparisonDialog;
